import React, { useEffect, useState } from "react";
import { useSelector, connect, useDispatch } from "react-redux";
import DisplayBox from "../../hoc/DisplayBox/DisplayBox";
import { REPORT, ACTIVITY_LOG_EVENT_TYPE, ACTIVITY_LOG_SELECT_MAP_REVERSED } from "../../shared/Constants";
import Button from "../../UI/Button/Button";
import classes from "./ReportingSearch.css";
import Message from "../../components/Message/Message";
import { setSearchState } from "../../store/actions/reporting";
import * as actions from "../../store/actions/index";
import { isStartDateGreaterThenEndDate } from "../../shared/utility";
import Input from "../../UI/Input/Input";
import { checkValidity, compareDates } from "../../shared/utility";
import Spinner from "../../UI/Spinner/Spinner";
import ReportSearchResult from "./ReportingSearchTable";

const ReportingForm = (props) => {
  const dispatch = useDispatch();

  const errorMsg = useSelector((state) => state.reporting.error);
  const showSpinner = useSelector((state) => state.reporting.showSpinner);
  const report = useSelector((state) => state.reporting.report);
  const [csvInfo, setCsvInfo] = useState(null);
  const [statusFormValid, setStatusFormValid] = useState(false);
  const errorHandler = (error) => {
    props.setError(error);
  };

  const [formInputElements, setFormInputElements] = useState({
    startDate: {
      elementType: "input",
      elementConfig: {
        type: "date",
        id: "startDate",
        placeholder: "99-99-9999",
        min: formatDate(),
        max: "9999-12-31",
      },
      value: props.startDateValue,
      validation: {
        required: false,
        restrictFuture: true,
      },
      valid: true,
      touched: false,
      label: "Start Date",
      inputType: "OneThird",
    },
    endDate: {
      elementType: "input",
      elementConfig: {
        type: "date",
        id: "endDate",
        placeholder: "99-99-9999",
        min: formatDate(),
        max: "9999-12-31",
      },
      value: props.endDateValue,
      validation: {
        required: false,
        restrictFuture: true,
      },
      valid: true,
      touched: false,
      label: "End Date",
      inputType: "OneThird",
    },
  });

  const resultColumnMapping = [
    {dataField: 'serialNumber', text: 'S. No.', title: true, label: 'S. No.', key: 'serialNumber'},
    {dataField: 'event', text: 'Functionality', title: true, label: 'Functionality', key: 'event'},
    {dataField: 'count', text: 'Usage (number of use)', title: true, label: 'Usage (number of use)', key: 'count'}
];

  const inputChangedHandler = (event, inputIdentifier) => {
    let updatedForm = { ...formInputElements };

    const updatedFormElement = { ...updatedForm[inputIdentifier] };
    updatedFormElement.value = event.target.value;
    if (event.target.value) {
      const validation = checkValidity(
        updatedFormElement.value,
        updatedFormElement.validation
      );
      updatedFormElement.valid = validation.isValid;
      errorHandler({ message: validation.message });
    } else {
      updatedFormElement.valid = true;
      errorHandler(null);
    }
    updatedFormElement.touched = true;
    updatedForm[inputIdentifier] = updatedFormElement;
    let formIsValid = true;
    for (let inputIdentifier in updatedForm) {
      formIsValid = updatedForm[inputIdentifier].valid && formIsValid && updatedForm[inputIdentifier].value != "";
    }
    if (inputIdentifier === "startDate") {
      setStartDate(event.target.value);
    } else {
      setEndDate(event.target.value);
    }
    if (
      formInputElements.startDate.value &&
      inputIdentifier === "endDate" &&
      !compareDates(formInputElements.startDate.value, event.target.value) &&
      event.target.value !== ""
    ) {
      errorHandler({
        message: "Start Date cannot be greater than End Date.",
      });
      formIsValid = false;
      updatedFormElement.valid = false;
    } else if (
      formInputElements.endDate.value &&
      inputIdentifier === "startDate" &&
      !compareDates(event.target.value, formInputElements.endDate.value) &&
      event.target.value !== ""
    ) {
      errorHandler({
        message: "Start Date cannot be greater than End Date.",
      });
      formIsValid = false;
      updatedFormElement.valid = false;
    }
    setStatusFormValid(formIsValid);
    setFormInputElements(updatedForm);
  };

  function formatDate() {
    const date = new Date();
    date.setMonth(date.getMonth() - 6);
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }

  function formatReportingSearchData(data) {
    return data.map((obj,i) => ({...obj, serialNumber:i+1, event: ACTIVITY_LOG_SELECT_MAP_REVERSED[obj.event] ? ACTIVITY_LOG_SELECT_MAP_REVERSED[obj.event].name : obj.event}))
  }

  useEffect(() => {
    props.isReportSearched(false);
    clearSearch();
    window.scrollTo(0, 0);
  }, []);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const formHeader = REPORT;
  const message = "";

  const reportSearchHandler = (eventR) => {
    eventR.preventDefault();

    let formData = {};

    if (isStartDateGreaterThenEndDate(startDate, endDate)) {
      props.setError({
        message: "Start Date cannot be greater than End Date.",
      });
      return;
    }
    formData["startDate"] = startDate;
    formData["endDate"] = endDate;
    formData["eventType"] = ACTIVITY_LOG_EVENT_TYPE[1];

    dispatch(setSearchState(formData));
    props.reportSearch(formData);
    props.isReportSearched(true);
    setCsvInfo(null);
  };

  const clearSearch = () => {
    setStartDate("");
    setEndDate("");

    formInputElements.startDate.value = "";
    formInputElements.startDate.touched = false;
    formInputElements.startDate.valid = true;

    formInputElements.endDate.value = "";
    formInputElements.endDate.touched = false;
    formInputElements.endDate.valid = true;

    dispatch(setSearchState(null));
    dispatch(actions.setError(null));
    dispatch(actions.resetSearchReports());
    setCsvInfo(null);
    setStatusFormValid(false);
  };

  const createForm = () => {
    const formsElementsArray = [];

    for (let key in formInputElements) {
      formsElementsArray.push({
        id: key,
        config: formInputElements[key],
      });
    }

    return (
      <form onSubmit={reportSearchHandler}>
        <div style={{ display: "flex", justifyContent: "center" }}>
          {formsElementsArray.map((formElement) => (
            <Input
              key={formElement.id}
              elementType={formElement.config.elementType}
              elementConfig={formElement.config.elementConfig}
              value={formElement.config.value}
              invalid={!formElement.config.valid}
              shouldValidate={formElement.config.validation}
              touched={formElement.config.touched}
              label={formElement.config.label}
              changed={(event) => inputChangedHandler(event, formElement.id)}
              extendedInput={formElement.config.extendedInput}
              inputType={formElement.config.inputType}
            />
          ))}
        </div>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Button
            id="cancelSearch"
            btnType="Cancel"
            clicked={clearSearch}
            attr={{ type: "button" }}
          >
            Cancel
          </Button>
          <Button
            id="reportSearch"
            btnType="Search"
            disabled={!statusFormValid}
          >
            Search
          </Button>
        </div>
      </form>
    );
  };

  return (
    <>
      {
        <DisplayBox>
          <div className={classes.SearchWindow}>
            <h2 className={classes.FormTitle}>{formHeader}</h2>
            <p className={classes.Message}>{message}</p>
            <Message msgType="Error" info={errorMsg} />
            {createForm()}
            {showSpinner ? (
              <Spinner />
            ) : (
              <ReportSearchResult
                data={formatReportingSearchData(report)}
                columns={resultColumnMapping}
                csvInfo={csvInfo}
                setCsvInfo={setCsvInfo}
              />
            )}
          </div>
        </DisplayBox>
      }
    </>
  );
};

export const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    isReportSearched: (searched) =>
      dispatch(actions.isReportSearched(searched)),
    setError: (error) => dispatch(actions.setError(error)),
    reportSearch: (formInputElements) =>
      dispatch(actions.reportSearch(formInputElements)),
  };
};

export default connect(null, mapDispatchToProps)(ReportingForm);
